
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './zero-conditional-explanation';
const mainimage = '/Images/zerocond1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "zerocond" },
];

const ZeroConditional = () => (
  <GrammarPageLayout
    level="A2"
    title="Zero Conditional"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Zero Conditional Exercises"
    seoDescription="Practice general truths, facts, and rules with the zero conditional: if + present simple, present simple. A2 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A2"
  />
);

export default ZeroConditional;
